/**
 * 回 super-admin 的跳转。
 *
 * **不需要判断对方登没登录**：super-admin 的路由守卫在没有 token 时会
 * `next('/login?redirect=' + to.path)`，自己就把人送去登录页、登录完再弹回来。
 * 我们统一送到入口页即可——自己去猜对方的登录态既做不准（跨域读不到 cookie），
 * 也会和它的守卫逻辑打架。
 */
import { clearSession } from "./session.ts";

/**
 * 我们的域名 → 对应环境 super-admin 的**完整入口地址**。
 *
 * 存整条 URL 而不是「域名 + 共用路径」：**test 站没有 `/superadmin` 前缀**
 * （Pages 部署在根路径），另外两个有。之前按共用路径拼，test 的链接
 * 一直是错的——多了一层 `/superadmin`，点过去 404。
 *
 * 路径差异这种事看不出规律，与其推导不如逐条写死。
 */
const ENTRY_BY_HOST: Record<string, string> = {
  // test
  "aeroplane-admin.pwtk-dev.work": "https://pb-super-admin-test.pages.dev/#/realGameManagement/guess",
  "aeroplane-admin.xdreamstar2025.workers.dev": "https://pb-super-admin-test.pages.dev/#/realGameManagement/guess",
  // 线上
  "aeroplane-admin.idolcard.cc": "https://super-admin.xcarefree.com/superadmin/#/realGameManagement/guess",
};

/** 本地开发指向 dev 的 super-admin */
const LOCAL_ENTRY = "https://pb-super-admin.pwtk.cc/superadmin/#/realGameManagement/guess";

/** 飞行棋在 super-admin 里的入口：实体游戏管理页 */
export function superAdminEntry(): string {
  const host = typeof location !== "undefined" ? location.hostname : "";
  if (host === "localhost" || host === "127.0.0.1") return LOCAL_ENTRY;
  return ENTRY_BY_HOST[host] ?? LOCAL_ENTRY;
}

/** 仅取站点根，用于展示 */
export const superAdminBase = () => new URL(superAdminEntry()).origin;

/**
 * 凭据失效时回 super-admin 重新进入。
 *
 * 用 replace 而不是 assign：让用户按「后退」不会又弹回这个已经没法用的页面，
 * 在两个页面之间来回跳。
 */
export function bounceToSuperAdmin(reason: "unauthorized" | "expired" | "missing"): void {
  // 清掉手里这张已经不管用的票，避免回来后又拿它去打接口
  // 存储不可用时 clearSession 自己吞掉错误，跳转本身不该因此失败
  clearSession();
  void reason;
  location.replace(superAdminEntry());
}
